/**
 * @returns {{
 *   [key: string]: string[] | undefined
 * }}
 */
function defaultHotkeys() {
  // Not editable
  // cancel_selected_action: 'Escape',
  // practice_next_hand: 'Enter NumpadEnter',
  // practice_full_hand_next_spot: 'ArrowRight'
  // practice_full_hand_previous_spot: 'ArrowLeft'

  // practice_builder_focus_action: 'Tab',
  // practice_builder_lock_paint: 'CapsLock'
  // practice_builder_history_undo: 'ctrlKey KeyZ',
  // practice_builder_history_redo: 'ctrlKey KeyY',

  // hand_replay_next_spot: 'ArrowRight'
  // hand_replay_previous_spot: 'ArrowLeft'
  // hand_replay_next_hand: 'ArrowDown'
  // hand_replay_previous_hand: 'ArrowUp',
  // _123 : Numpad1 Digit1
  // study_to_switch_strategy : Numpad1 Digit1

  // study_switch_street_card: arrows + shiftKey
  // study_switch_gmf: arrowUp

  return {
    // switch_pot_bb: ['Space'],
    // drawing_mode: ['KeyB'],
    // focus_mode: ['KeyF'],
    // switch_actions_grouping: ['KeyS'],

    // study_fullscreen_mode: ['KeyQ'],
    // study_reports_turn_view: ['KeyW'],
    // study_reset_filters: ['KeyP'],

    // practice_replay_hand: ['KeyR'],
    // practice_play_new_hand: ['KeyE'],
    // practice_hero_frequency: ['KeyH'],
    // action_check_fold: ['KeyX'],
    // action_call: ['KeyC'],
    // action_allin: ['KeyZ'],

    // reset_history: ['KeyG'],
    // expand_history: ['KeyL'],
    // save_spot: ['KeyM'],
    // open_shortcuts: ['KeyJ'],

    switch_pot_bb: ['space'],
    switch_ev_pot: ['space', 'shift'],

    drawing_mode: ['b'],
    focus_mode: ['f'],
    switch_actions_grouping: ['s'],

    study_fullscreen_mode: ['q'],
    study_reports_turn_view: ['w'],
    study_reset_filters: ['p'],

    practice_study_spot: ['shift', 's'],
    practice_replay_hand: ['r'],
    practice_play_new_hand: ['e'],
    practice_hero_frequency: ['h'],
    action_check_fold: ['x'],
    action_call: ['c'],
    action_allin: ['z'],

    reset_history: ['g'],
    expand_history: ['l'],
    save_spot: ['m'],
    open_shortcuts: ['j'],

    // test: {
    //     Space: '',
    //     B: '',
    //     F: '',
    //     S: '',
    //     Q: '',
    //     W: '',
    //     P: '',
    //     R: '',
    //     E: '',
    //     H: '',
    //     X: '',
    //     C: '',
    //     G: '',
    //     L: '',
    //     M: '',
    //     J: '',
    // },
  }
}

// function confHotkeys() {
//     return {
//         global: [
//             // 'close'
//             // 'confirm'
//             // 'switch_pot_bb',
//             // 'drawing_mode',
//             // 'focus_mode',
//             'reset_history',
//             // 'open_shortcuts',
//             // 'switch_action_view',
//         ],
//         study: [
//             'reset_history',
//         ],
//         trainer: [
//             'reset_history',
//         ],
//         builder: [
//             'reset_history',
//         ],
//         replayer: [],
//     }
// }

// https://github.com/jaywcjlove/hotkeys/blob/master/src/var.js - helpfull list
function getHotkeyCode(e) {
  const modifiers = {
    _16: 'shift',
    _17: 'control',
    _18: 'alt',
    _91: 'command', // Meta on Mac
    _93: 'command', // Meta on Mac
  }
  // const modifiers = {
  //     _16: 'Shift',
  //     _17: 'Control',
  //     _18: 'Alt',
  //     _91: 'Command', // Meta on Mac
  //     _93: 'Command', // Meta on Mac
  // }
  let code = e.code || ''
  if (modifiers[`_${e?.keyCode}`]) {
    code = modifiers[`_${e?.keyCode}`]
  } else if (code === 'NumpadEnter') {
    code = 'Enter'
  } else if (code.includes('CapsLock')) {
    code = null
  } else if (code.includes('Numpad') || code.includes('Digit')) {
    // [shift + 1] returns [!] so we cannot use key
    code = code.replace('Digit', '')
    code = code.replace('Numpad', '')
  } else {
    // A-Z -- 0-9 use key instead of code
    code = code.includes('Key') ? e.key : code
  }

  code = !code ? null : code.toLowerCase()
  return code
}

function getHotkeysConf({ apiConf }) {
  const res = {}
  Object.keys(apiConf).forEach(key => {
    const keyCombination = [apiConf[key]].flat() // legacy - hotkey can be string - delete after 1.9 2023 (should be long enough)
    // let displayCombination = keyCombination.flat().map(k => k.replace('Key', '')).join('+')
    const displayCombination = keyCombination
      .flat()
      .map(k => k.replace('Key', ''))
      .join('+')
    res[key] = {
      keyCombination,
      displayCombination,
    }
  })
  return res
}

export { defaultHotkeys, getHotkeyCode, getHotkeysConf }
